import { ITaskController } from "Interfaces/Controllers/ITaskController";
import { inject, injectable } from "inversify";
import fileDownload from "js-file-download";
import { Dispatch } from "redux";
import Types from "ServiceProvider/Types";
import { ActionTypes, TaskActions } from "./TaskActionTypes";

export interface ITaskAction {
    exportTasksAsync(fromDate: Date, toDate: Date): any;
    close(): any;
}

@injectable()
export class TaskAction implements ITaskAction {

    public constructor(
        @inject(Types.ITaskController) private taskController: ITaskController) {
    }

    public exportTasksAsync(fromDate: Date, toDate: Date) {
        return async (dispatch: Dispatch<TaskActions>) => {
            const data = await this.taskController.export(fromDate, toDate);
            fileDownload(data, "export.csv");

            dispatch({
                type: ActionTypes.CSV_DOWNLOADED
            });
        };
    }

    public close() {
        return async (dispatch: Dispatch<TaskActions>) => {
            dispatch({
                type: ActionTypes.CLEAR
            });
        };
    }
}



// WEBPACK FOOTER //
// ./src/Store/Tasks/TaskAction.ts